import React, { useState } from "react";
import AICHATBOT from "../../assets/aichatbot.jpg";
import { CheckIcon } from "@heroicons/react/24/outline";

const Features = () => {
  const [feature, setFeature] = useState("personalized");

  const featuresData = {
    personalized: {
      title: "Personalized insights",
      content: [
        "Wonder how Ranveer started his YouTube journey?",
        "Curious about the journey of being a solo founder with no money, just like Raj?",
        "Need advice from Ankur on managing your personal finances?",
        "Get personalized insights from the best in the business.",
      ],
    },
    multilingual: {
      title: "Multilingual Conversations",
      content: [
        "Communicate effortlessly with the digital clones in any language of your choice, breaking language barriers.",
        "Explore diverse cultures and perspectives through multilingual interactions, promoting global understanding.",
      ],
    },
    liveInteractive: {
      title: "Live Interactive Sessions",
      content: [
        "Participate in live Q&A sessions, workshops, and interactive discussions with the digital clones, allowing direct engagement.",
        "Gain access to exclusive virtual events where you can interact with the digital clones, fostering a sense of community.",
      ],
    },
  };

  const handleFeatureClick = (key) => {
    setFeature(key);
  };

  return (
    <>
      <div class="text-center mb-20">
        <h1 class="sm:text-3xl text-2xl font-medium title-font text-gray-900 mb-4">
          Introducing The
          <span className="text-[#7C82FF] ml-2">AI-Powered </span>
          Suite
          <br />
          Your Virtual VIP Pass!
        </h1>
        <p class="text-lg leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto text-gray-500s">
          Experience Personalized Conversations with Your Favorite Creators,
          Instantly!
        </p>
        <div class="flex mt-6 justify-center">
          <div class="w-16 h-1 rounded-full bg-indigo-500 inline-flex"></div>
        </div>
      </div>
      <div className="w-full sm:flex">
        <div className="bg-[#484687] w-full rounded-lg md:mx-6 lg:mx-48 p-4">
          <div className="flex justify-around items-center text-white mb-4">
            {Object.keys(featuresData).map((key) => (
              <div
                key={key}
                className={`px-4 py-2 md:text-xl text-sm  rounded-md cursor-pointer ${
                  feature === key
                    ? "hover:text-[#6C70DD]"
                    : "hover:text-[#6C70DD] transition duration-300"
                }`}
                onClick={() => handleFeatureClick(key)}
              >
                {featuresData[key].title}
              </div>
            ))}
          </div>
          <div className="bg-[#32325D] flex flex-col md:flex-row rounded-md items-center text-white">
            <div className="bg-white text-gray-800 p-6 h-3/4 pb-16 pt-16 md:ml-8  rounded-md flex flex-col justify-start w-full md:w-1/2">
              <h3 className="text-2xl font-poppins font-semibold mb-4">
                {featuresData[feature].title}
              </h3>
              <ul className="list-none text-left space-y-3">
                {featuresData[feature].content.map((item, index) => (
                  <li
                    key={index}
                    className="text-lg font-poppins leading-relaxed flex items-center"
                  >
                    <CheckIcon className="text-green-500 w-8 h-8 mr-2" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="md:w-1/2 flex justify-center items-center p-4">
              <img
                src={AICHATBOT}
                alt="AI Chatbot"
                className="rounded-md object-cover object-center w-11/12 h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Features;
